export default "__VITE_ASSET__BqlW1Y83__";